export const APP_STORE_URL =
  "https://apps.apple.com/app/apple-store/id1592176024?pt=123329576&ct=DwellSocialHomepage&mt=8";
